// apps/web/src/lib/vocabulary/useTerm.ts
//
// Phase 9 Plan 04 Task 2 — Single-source vocabulary read hook (D-14).
//
// Mirrors apps/web/src/widgets/use-other-widget-state.ts verbatim shape:
// useContext → throw-if-outside-provider → narrow + return. Pure context
// read; no form-state subscription, no useWatch, no module-mutable state.
//
// The hook is the SOLE rendering path for vocabulary labels in apps/web.
// Plan 09-08 + Plan 09-13 grep gates enforce: hardcoded "Spread" / "Batch Set" /
// "Set" / "Item" strings inside apps/web/src/pages/spread/** and the new
// constraint section files fail the gate; the allowlist covers
// VOCABULARY_DEFAULTS source, fixture files, and test files (per RESEARCH
// §"Vocabulary defaults are easy to remember and forget to wrap in useTerm()").
//
// Falls back to VOCABULARY_DEFAULTS[slot] when overrides[slot] is undefined —
// the frozen-defaults invariant guarantees the fallback is referentially
// stable across the SSR/client boundary (Phase 13).
import { VOCABULARY_DEFAULTS, type VocabularySlot } from "@the-recipe-spread/shared";
import { useContext } from "react";
import { SpreadVocabularyContext } from "./SpreadVocabularyProvider.js";

export function useTerm(slot: VocabularySlot): string {
  const ctx = useContext(SpreadVocabularyContext);
  if (ctx === null) {
    throw new Error(
      "useTerm must be called inside <SpreadVocabularyProvider>. " +
        "Wrap your spread tree in the provider at the SpreadComposer level.",
    );
  }
  return ctx.overrides[slot] ?? VOCABULARY_DEFAULTS[slot];
}
